import { AiOutlineHome } from "react-icons/ai";
import { HiOutlineUserGroup } from "react-icons/hi2";
import { CgWebsite } from "react-icons/cg";
import { LuUser2 } from "react-icons/lu";
import { BiBookAlt } from "react-icons/bi";
import { GrServices } from "react-icons/gr";
import { MdContactPhone } from "react-icons/md";
import { FaAward, FaFacebook, FaGithub } from "react-icons/fa6";
import { RiMessengerLine } from "react-icons/ri";
interface ILinks {
  title: string;
  href: string;
  icon: JSX.Element;
}
interface IAboutCard {
  icon: JSX.Element;
  title: string;
  desc: string;
}

interface ILanguages {
  language:
    | "HTML"
    | "JavaScript"
    | "CSS"
    | "TypeScript"
    | "React"
    | "NextJS"
    | "NodeJS"
    | "MongoDB"
    | "Mongoose"
    | "Prisma"
    | "C++"
    | "Redux"
    | "MERN Stack"
    | "Design";

  levelOfExperience: "Experienced" | "Intermediate";
}
interface ILanguageSeries {
  frontend: ILanguages[];
  backend: ILanguages[];
}

interface IServices {
  serviceName: string;
  serviceDetails: string[];
}
interface ISocialLinks {
  id: number;
  url: string;
  icon: JSX.Element;
}

export const links: ILinks[] = [
  {
    title: "home",
    href: "#home",
    icon: <AiOutlineHome />,
  },
  {
    title: "about",
    href: "#about",
    icon: <LuUser2 />,
  },
  {
    title: "experience",
    href: "#experience",
    icon: <BiBookAlt />,
  },
  {
    title: "services",
    href: "#services",
    icon: <GrServices />,
  },
  {
    title: "contact",
    href: "#contact",
    icon: <MdContactPhone />,
  },
];

export const aboutCards: IAboutCard[] = [
  {
    icon: <FaAward className="about-icon" />,
    title: "Experience",
    desc: "10+ years working",
  },
  {
    icon: <HiOutlineUserGroup className="about-icon" />,
    title: "Clients",
    desc: "100+ Worldwide",
  },
  {
    icon: <CgWebsite className="about-icon" />,
    title: "Projects",
    desc: "50+ Completed projects",
  },
];

export const expertise: ILanguageSeries = {
  frontend: [
    {
      language: "HTML",
      levelOfExperience: "Experienced",
    },
    {
      language: "CSS",
      levelOfExperience: "Experienced",
    },
    {
      language: "JavaScript",
      levelOfExperience: "Experienced",
    },
    {
      language: "React",
      levelOfExperience: "Experienced",
    },
    {
      language: "TypeScript",
      levelOfExperience: "Experienced",
    },
    {
      language: "Redux",
      levelOfExperience: "Experienced",
    },
    {
      language: "Design",
      levelOfExperience: "Experienced",
    },
  ],
  backend: [
    {
      language: "NodeJS",
      levelOfExperience: "Experienced",
    },
    {
      language: "NextJS",
      levelOfExperience: "Experienced",
    },
    {
      language: "MERN Stack",
      levelOfExperience: "Experienced",
    },
    {
      language: "MongoDB",
      levelOfExperience: "Experienced",
    },
    {
      language: "Mongoose",
      levelOfExperience: "Experienced",
    },
    {
      language: "Prisma",
      levelOfExperience: "Experienced",
    },
    {
      language: "C++",
      levelOfExperience: "Experienced",
    },
  ],
};

export const services: IServices[] = [
  {
    serviceName: "Web Development",
    serviceDetails: [
      "Fullstack development",
      "E-commerce development",
      "Website development",
      "Backend development",
      "Web optimization",
      "Web design",
      "API development",
      "Database development",
    ],
  },
];
export const socialLinks: ISocialLinks[] = [
  {
    id: 1,
    url: "https://www.facebook.com/profile.php?id=100092407891758",
    icon: <FaFacebook className="social-img" />,
  },
  {
    id: 2,
    url: "https://github.com/engmhajj",
    icon: <FaGithub className="social-img" />,
  },
  {
    id: 3,
    url: "https://m.me/100092407891758",
    icon: <RiMessengerLine className="social-img" />,
  },
];
